import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import {EngineeringColumn} from './engineering-column';
import {ProjectStatus} from '../../../project-misc/data/project/statuses/project-status';

@JsonObject('model.EngineeringData')
export class EngineeringData extends AbstractModel {

    @JsonProperty([EngineeringColumn], 'columns')
    columns?: EngineeringColumn[];

    @JsonProperty([ProjectStatus], 'statuses')
    statuses?: ProjectStatus[];

}
